import { Button, Modal, ThemeProvider, createTheme } from '@mui/material'
import React, { useState } from 'react'
import styles from './ImageLightbox.module.scss'

interface Props {
  src: string
  alt: string
  imageStyle?: string
  containerStyle?: string
  rounded?: boolean
  noBackground?: boolean
  theftIndicator?: boolean
  financialIndicator?: boolean
  isDocument?: boolean
  blockedMaintenance?: boolean
}

const ImageLightBox = ({
  src,
  alt,
  imageStyle,
  containerStyle,
  rounded,
  noBackground,
  theftIndicator,
  financialIndicator,
  isDocument,
  blockedMaintenance
}: Props) => {
  const [visible, toggleVisible] = useState<boolean>(false)
  const [rotation, setRotation] = useState<number>(0)

  const handleOpen = () => {
    if (
      src === '/static/media/marcadguant.538dd6d3ae68fcf09363.png' ||
      src ===
        'data:image/png;base64,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'
    )
      return
    toggleVisible(true)
  }

  const handleClose = () => {
    toggleVisible(false)
  }

  const rotate = () => {
    let newRotation = rotation + 90
    if (newRotation >= 360) {
      newRotation = 0
    }
    setRotation(newRotation)
  }

  const theme = createTheme({
    palette: {
      primary: {
        main: '#3366FF'
      },
      secondary: {
        main: '#4E5F78'
      },
      error: {
        main: '#D32E2E'
      },
      warning: {
        main: '#FFC000'
      },
      mode: 'light'
    },
    typography: {
      fontFamily: ['Montserrat', 'sans-serif'].join(','),
      button: {
        textTransform: 'none'
      }
    }
  })

  return (
    <ThemeProvider theme={theme}>
      <div role="navigation" className={containerStyle}>
        <button
          className={`${styles.imageButton} ${rounded ? styles.rounded : ''} ${
            noBackground ? styles.noBackground : ''
          }`}
          type="button"
          onClick={handleOpen}
        >
          <img className={imageStyle} src={src} alt={alt} />
          {theftIndicator && (
            <div className={styles.theftIndicator}>
              <p>Alerta de Roubo</p>
            </div>
          )}
          {financialIndicator && (
            <div className={styles.financialIndicator}>
              <p>Restrição Finanaceira</p>
            </div>
          )}
          {blockedMaintenance && (
            <div className={styles.blockedMaintenance}>
              <p>Bloqueada Manutenção</p>
            </div>
          )}
        </button>
      </div>
      <Modal
        open={visible}
        onClose={handleClose}
        onBackdropClick={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={styles.modalContent}>
          <div className={styles.imageContainer}>
            <div className={styles.modalHeader}>
              {isDocument && (
                <Button
                  color="primary"
                  variant="contained"
                  className="me-3"
                  onClick={rotate}
                >
                  Rotacionar
                </Button>
              )}
              <Button color="primary" variant="contained" onClick={handleClose}>
                Fechar
              </Button>
            </div>
            <img
              className={styles.modalImage}
              // style={{
              //   transform: `rotate(${rotation}deg)`
              // }}
              src={src}
              alt={alt}
            />
          </div>
        </div>
      </Modal>
    </ThemeProvider>
  )
}

ImageLightBox.defaultProps = {
  imageStyle: '',
  containerStyle: ''
}

export default ImageLightBox
